import { FC } from "react";
import type { ComponentProps } from "react";
import type Link from "next/link";
import { useRouter } from "next/router";

import ArrowLeftIcon from "@src/lib/icons/18px/arrow-left";
import { Button } from "@src/lib/ui/Button";

type LinkHref = ComponentProps<typeof Link>["href"];

type Props = {
  href: LinkHref;
  // Replace instead of push — for backs that unwind a sub-view, so browser
  // back doesn't reopen it.
  replace?: boolean;
};

const BuilderHeaderBackButton: FC<Props> = ({ href, replace = false }) => {
  const router = useRouter();

  return (
    <Button
      type="button"
      variant="ghost"
      size="icon-md"
      aria-label="Back"
      className="size-7 shrink-0 rounded-md text-gray-9 hover:!bg-black-alpha-2 hover:text-gray-12"
      onClick={() => (replace ? router.replace(href) : router.push(href))}
      data-testid="builder-header-back-button"
    >
      <ArrowLeftIcon className="size-4" />
    </Button>
  );
};

export default BuilderHeaderBackButton;
